import type { AuthService } from "../port/AuthService";
import type { SessionStore } from "../port/SessionStore";

export class Logout {
  constructor(
    private readonly service: AuthService,
    private readonly sessionStore: SessionStore,
  ) {}

  async execute(): Promise<void> {
    try {
      await this.service.logout();
    } finally {
      this.sessionStore.set(null)
    }
  }
}
